export enum FinderReward {
    Paypal = "Paypal",
    Transfer = "Transfer",
    AmazonVoucher = "AmazonVoucher",
    NoReward = "NoReward"
  }
  